module.exports = "/images/dropDownIcon.png?e05d16d4d3d5cc1ec24bb9c20cea6185";